import { render } from "./FeeTypeManagement.vue?vue&type=template&id=160cfcb2&scoped=true"
import script from "./FeeTypeManagement.vue?vue&type=script&lang=js"
export * from "./FeeTypeManagement.vue?vue&type=script&lang=js"

import "./FeeTypeManagement.vue?vue&type=style&index=0&id=160cfcb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160cfcb2"]])

export default __exports__